import * as React from 'react';
import { FC } from 'react';
import { GridColDef, GridRowsProp } from '@mui/x-data-grid-pro';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { Box } from '@mui/material';

const dsgvoRows: GridRowsProp = [
  {
    id: 1,
    col1: 'ua',
    col2: 'Device manufacturer incl. device type',
    col3: 'Ensuring an appealing, smooth presentation of the experiments and the evaluation\t ',
  },
  {
    id: 2,
    col1: 'BrowserInfo',
    col2: 'Browser type incl. version number',
    col3: 'Ensuring an appealing, smooth presentation of the experiments and the evaluation',
  },
  {
    id: 3,
    col1: 'DeviceInfo',
    col2: 'Device manufacturer incl. device type',
    col3: 'Ensuring an appealing, smooth presentation of the experiments and analyses',
  },
  {
    id: 4,
    col1: 'EngineInfo',
    col2: 'Browser engine incl. version number',
    col3: 'Ensuring an appealing, smooth presentation of the experiments and analyses',
  },
  {
    id: 5,
    col1: 'OsInfo',
    col2: 'Operating system type incl. version number',
    col3: 'Ensuring an appealing, smooth presentation of the experiments and analyses',
  },
  {
    id: 6,
    col1: 'CpuInfo',
    col2: 'Manufacturer of the processor with model designation',
    col3: 'Performance assessment (evaluation of time sequences) and error analysis',
  },
  {
    id: 7,
    col1: 'timing',
    col2: 'Date and time of access',
    col3: 'Administrative and evaluation purposes',
  },
  {
    id: 8,
    col1: 'key',
    col2: 'Keys pressed on the computer keyboard',
    col3: 'Recording the reaction of the test participants',
  },
];

const dsgvoColumns: GridColDef[] = [
  { field: 'id', hide: true },
  { field: 'col1', headerName: 'Data type', flex: 1 },
  { field: 'col2', headerName: 'Meaning', flex: 1 },
  { field: 'col3', headerName: 'Purpose of the processing', flex: 2 },
];

export const DsgvoTable: FC<{
  columns?: GridColDef[];
  rows?: GridRowsProp;
}> = ({ columns = [], rows = [] }) => (
  <Box height={530} mt={1}>
    <DataGridPro
      columns={[...dsgvoColumns, ...columns]}
      rows={[...dsgvoRows, ...rows]}
    />
  </Box>
);
